import { __rest } from "tslib";
import { api, apis, util, } from 'api';
import { createSlice } from '@reduxjs/toolkit';
import { MailActions } from './index';
import { buildContactModel, transEmailRoleBase2ContactModel, transServerCustomerContact2SimpleContactModel, transServerCustomerModel, } from '@web-common/utils/contact_util';
import { createAccountEmailKey, getMainAccount, parseAccountEmailKey } from '@web-common/components/util/contact';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import lodashKeyBy from 'lodash/keyBy';
import lodashOmit from 'lodash/omit';
import lodashOmitBy from 'lodash/omitBy';
import store from '@web-common/state/createStore';
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const mailPlusCustomerApi = api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
const eventApi = api.getEventApi();
const systemApi = api.getSystemApi();
const mergeContactData = (prevData, nextData) => {
    var _a, _b;
    if (prevData.customerOrgModel) {
        const nextInfo = (_a = nextData.customerOrgModel) === null || _a === void 0 ? void 0 : _a.relatedCompanyInfo;
        const prevInfo = (_b = prevData.customerOrgModel) === null || _b === void 0 ? void 0 : _b.relatedCompanyInfo;
        if (!(nextInfo === null || nextInfo === void 0 ? void 0 : nextInfo.length) && (prevInfo === null || prevInfo === void 0 ? void 0 : prevInfo.length)) {
            nextData.customerOrgModel.relatedCompanyInfo = prevInfo;
        }
    }
    else {
    }
};
const contactDataAddReduxParams = (list, isFull, _account) => {
    const reduxUpdateTime = Date.now();
    list.forEach(item => {
        Object.assign(item, { reduxUpdateTime, isFull, _account });
    });
    return list;
};
const InitialState = {
    orgMap: {},
    contactMap: {},
    emailMarkedMap: {},
    orgMarkedMap: {},
    emailIdMap: {},
    customerMap: {},
    contact: {},
    visitedCustomerContactMap: {},
    myCustomerList: {
        idList: [],
        loadMore: true,
        page: 0,
    },
    selector: {
        focused: '',
        add: false,
        pendingItem: [],
    },
    selectedTags: {
        type: '',
        emails: [],
    },
    currentEditingMail: {
        type: '',
        current: '',
    },
    canShowContactMultPanel: false,
    checkedContacts: [],
    mailListConfig: null,
    contactMapCleanTimes: 0,
};
const contactSlice = createSlice({
    name: 'contactReducer',
    initialState: InitialState,
    reducers: {
        doUpdateMailListConfig: (state, action) => {
            state.mailListConfig = action.payload;
        },
        doResetContactData(state, action) {
            const { updateContactMap = {}, updateCustomerMap = {}, updateEmailIdMap = {} } = action.payload;
            state.contactMapCleanTimes += 1;
            state.contactMap = updateContactMap;
            state.emailIdMap = updateEmailIdMap;
            state.customerMap = updateCustomerMap;
        },
        doCleanContactMap(state) {
            state.contactMap = {};
            state.emailIdMap = {};
            state.contactMapCleanTimes += 1;
        },
        doDeleteContactMap(state, action) {
            const { idList, _account = getMainAccount() } = action.payload;
            if (idList === null || idList === void 0 ? void 0 : idList.length) {
                state.emailIdMap = lodashOmitBy(state.emailIdMap, (id, accountEmail) => {
                    const parseRes = parseAccountEmailKey(accountEmail);
                    return idList.includes(id) && (parseRes === null || parseRes === void 0 ? void 0 : parseRes.account) === _account;
                });
                state.contactMap = lodashOmit(state.contactMap, idList);
            }
        },
        doCleanCustomerMap(state) {
            state.customerMap = {};
        },
        doUpdateEmailMarkedMap: (state, action) => {
            const { data, type, isAll } = action.payload;
            data.forEach((idSet, email) => {
                const idList = [...idSet];
                if (type === 'add') {
                    const oldList = state.emailMarkedMap[email];
                    if (isAll) {
                        if (!isEqual(oldList, idList)) {
                            state.emailMarkedMap[email] = idList;
                        }
                    }
                    else {
                        state.emailMarkedMap[email] = [...new Set([...(oldList || []), ...idList])];
                    }
                }
                else if (type === 'cancel') {
                    if (isAll) {
                        state.emailMarkedMap[email] = [];
                    }
                    else {
                        const oldList = state.emailMarkedMap[email] || [];
                        const data = new Set(oldList);
                        idList.forEach(id => {
                            data.delete(id);
                        });
                        state.emailMarkedMap[email] = [...data];
                    }
                }
            });
        },
        doUpdateOrgMarkedMap: (state, action) => {
            const data = action.payload || new Set();
            data.forEach((item, orgId) => {
                const oldData = state.orgMarkedMap[orgId];
                if (!!item !== !!oldData) {
                    state.orgMarkedMap[orgId] = !!item;
                }
            });
        },
        _doUpdateContactMap: (state, action) => {
            var _a;
            const contactMap = action.payload;
            const updateContactMap = {};
            (_a = Object.keys(contactMap)) === null || _a === void 0 ? void 0 : _a.forEach(id => {
                const nextData = contactMap[id];
                const prevData = state.contactMap[id];
                const isFull = nextData.isFull === undefined ? true : nextData.isFull;
                const _account = nextData._account || getMainAccount();
                const now = Date.now();
                if (!prevData) {
                    updateContactMap[id] = Object.assign(Object.assign({}, nextData), { reduxUpdateTime: now, isFull, _account });
                }
                else {
                    const { reduxUpdateTime } = prevData, oldModel = __rest(prevData, ["reduxUpdateTime"]);
                    if (!oldModel || !isEqual(oldModel, nextData)) {
                        mergeContactData(prevData, nextData);
                        updateContactMap[id] = Object.assign(Object.assign({}, nextData), { reduxUpdateTime: now, isFull, _account });
                    }
                }
            });
            if (!isEmpty(updateContactMap)) {
                Object.assign(state.contactMap, updateContactMap);
            }
        },
        _doUpdateEmailIdMap: (state, action) => {
            const updateEmailIdData = action.payload;
            if (!isEmpty(updateEmailIdData)) {
                Object.assign(state.emailIdMap, updateEmailIdData);
            }
        },
        doUpdateCustomerMap: (state, action) => {
            var _a;
            const customerMap = action.payload;
            const updateCustomerMap = {};
            (_a = Object.keys(customerMap)) === null || _a === void 0 ? void 0 : _a.forEach(customerId => {
                const nextData = customerMap[customerId];
                const prevData = state.customerMap[customerId];
                if (!prevData) {
                    updateCustomerMap[customerId] = Object.assign(Object.assign({}, nextData), { reduxUpdateTime: Date.now() });
                }
                else {
                    const { reduxUpdateTime } = prevData, oldModel = __rest(prevData, ["reduxUpdateTime"]);
                    if (!oldModel || !isEqual(oldModel, nextData)) {
                        updateCustomerMap[customerId] = Object.assign(Object.assign({}, nextData), { reduxUpdateTime: Date.now() });
                    }
                }
            });
            if (!isEmpty(updateCustomerMap)) {
                Object.assign(state.customerMap, updateCustomerMap);
            }
        },
        doUpdateMyCustomerList: (state, action) => {
            const { idList, loadMore, page } = action.payload;
            state.myCustomerList.idList = idList;
            state.myCustomerList.loadMore = loadMore;
            state.myCustomerList.page = page;
        },
        doCleanMyCustomerList: state => {
            state.myCustomerList = {
                idList: [],
                loadMore: true,
                page: 0,
            };
        },
        doUpdateOrgMap: (state, action) => {
            action.payload.forEach(item => {
                state.orgMap[item.id] = item;
            });
        },
        doCreateFormExternal: (state, action) => {
            state.contact.external = action.payload;
        },
        doCreateAfterFlag: (state, action) => {
            state.contact.createFlag = action.payload;
        },
        doFocusSelector: (state, action) => {
            state.selector.focused = action.payload;
            state.selectedTags = { emails: [], type: '' };
        },
        doAddItemToSelector: (state, action) => {
            const { add, pendingItem } = action.payload;
            state.selector.add = add;
            state.selector.pendingItem = pendingItem;
        },
        doSelectTags: (state, action) => {
            const { type, emails } = action.payload;
            state.selectedTags.type = type;
            state.selectedTags.emails = Array.from(new Set(emails));
            state.selector.focused = type;
        },
        doSetCurrentEditingMail: (state, action) => {
            const { type, current } = action.payload;
            state.currentEditingMail = { type, current };
        },
        doUpdateContactMultPanelVisible: (state, action) => {
            state.canShowContactMultPanel = action.payload;
        },
        doUpdateCheckedContacts: (state, action) => {
            state.checkedContacts = action.payload;
        },
        doUpdateVisitedCustomerContactMap: (state, action) => {
            const { id, data } = action.payload;
            if (!id || !data) {
                return;
            }
            state.visitedCustomerContactMap[id] = data;
        },
        doCleanVisitedCustomerContactMap: state => {
            state.visitedCustomerContactMap = {};
        },
    },
    extraReducers: builder => {
        builder.addCase(MailActions.doCloseMail, state => {
            state.selectedTags = { emails: [], type: '' };
        });
    },
});
export const doGetContactListAsync = async (idList, _account = getMainAccount()) => {
    try {
        const data = await contactApi.doGetContactById(idList, _account);
        doUpdateLxContactMap({ [_account]: data });
    }
    catch (error) {
    }
};
const getCustomerDataByIds = async (ids, updateCustomerIdRoleMap) => {
    var _a;
    if (process.env.BUILD_ISLINGXI && !((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion)) {
        return {
            data: [],
            customerContactList: [],
            customerList: [],
            contactMap: [],
            customerMap: [],
        };
    }
    const data = await mailPlusCustomerApi.doGetCustomerDataByIds(ids, updateCustomerIdRoleMap);
    const { customerContactList, customerList, contactMap, customerMap } = transServerCustomerModel(data);
    return {
        data,
        customerContactList,
        customerList,
        contactMap,
        customerMap,
    };
};
export const doGetCustomersByIds = async (customerIds, from = 'redux') => {
    if (!(customerIds === null || customerIds === void 0 ? void 0 : customerIds.length)) {
        return [];
    }
    let customerList = [], requesetIds = customerIds;
    if (from === 'redux') {
        const { customerMap } = store.getState().contactReducer;
        const res = customerIds.reduce((obj, customerId) => {
            if (customerId) {
                const current = customerMap[customerId];
                if (current) {
                    obj.customerList.push(current);
                }
                else {
                    obj.requesetIds.push(customerId);
                }
            }
            return obj;
        }, {
            customerList: [],
            requesetIds: [],
        });
        customerList = res.customerList;
        requesetIds = res.requesetIds;
    }
    if (requesetIds.length) {
        const result = await doGetCustomersByIdsFromServer({ idList: requesetIds });
        if (result) {
            customerList = [...customerList, ...result];
        }
    }
    return customerList;
};
const filterContactListAndCustomer = (customerEmailList, contactMap, customerMap) => {
    var _a;
    const contactEmailMap = (_a = Object.keys(contactMap)) === null || _a === void 0 ? void 0 : _a.reduce((obj, customerId) => {
        const contactList = contactMap[customerId];
        const emailSet = contactList.reduce((res, cur) => {
            const email = contactApi.doGetModelDisplayEmail(cur);
            if (email) {
                res.add(email);
            }
            return res;
        }, new Set());
        obj.set(customerId, emailSet);
        return obj;
    }, new Map());
    const needDeleteCustomerIdSet = new Set([...contactEmailMap.keys()]);
    const accountEmailMap = {};
    const emailNameMap = new Map();
    customerEmailList.forEach(obj => {
        const { email, customerId, _account, name } = obj;
        emailNameMap.set(email, name || email);
        const emails = contactEmailMap.get(customerId) || new Set();
        if (emails.has(email)) {
            needDeleteCustomerIdSet.delete(customerId);
        }
        else {
            const emails = accountEmailMap[_account] || [];
            emails.push(email);
            accountEmailMap[_account] = emails;
        }
    });
    return {
        accountEmailMap,
        customerMap,
        emailNameMap,
    };
};
export const doGetCustomersByIdsFromServer = async (params) => {
    const { idList, requestEmails } = params;
    try {
        let { customerList, contactMap, customerMap } = await getCustomerDataByIds(idList);
        const deleteIdList = new Set(idList);
        if (customerList.length) {
            customerList.forEach(item => {
                const customerId = item.id;
                if (deleteIdList.has(customerId)) {
                    deleteIdList.delete(customerId);
                }
            });
        }
        const deleteCustomerIdList = [...deleteIdList];
        const deleteContactIdList = [];
        if (deleteIdList.size) {
            const res = getCustomerLinkData(deleteCustomerIdList);
            deleteContactIdList.push(...res.contactIdList);
        }
        let accountEmailMap = {};
        let emailNameMap = new Map();
        if (requestEmails && requestEmails.length > 0) {
            const res = filterContactListAndCustomer(requestEmails, contactMap, customerMap);
            accountEmailMap = res.accountEmailMap;
            customerMap = res.customerMap;
            emailNameMap = res.emailNameMap;
        }
        let updateContactMap = {};
        let updateCustomerMap = {};
        if (!isEmpty(customerMap)) {
            updateCustomerMap = customerMap;
        }
        let updateEmailIdMap = {};
        if (!isEmpty(accountEmailMap)) {
            const { updateEmailIdMap: _updateEmailIdMap, updateContactMap: _updateContactMap, updateCustomerMap: _updateCustomerMap, } = await getEmailRoleAndDetailByEmails(accountEmailMap, emailNameMap);
            if (!isEmpty(_updateContactMap)) {
                updateContactMap = Object.assign({}, _updateContactMap);
            }
            if (!isEmpty(_updateCustomerMap)) {
                updateCustomerMap = Object.assign(Object.assign({}, updateCustomerMap), _updateCustomerMap);
            }
            if (!isEmpty(_updateEmailIdMap)) {
                updateEmailIdMap = _updateEmailIdMap;
            }
        }
        setContactReducerStateData({
            updateContactMap,
            updateEmailIdMap,
            updateCustomerMap,
            deleteCustomerIdList,
            deleteContactIdList,
        });
        return customerList;
    }
    catch (error) {
        console.error('[contact_reducer] doGetCustomerByIdsAsync error', error);
        return [];
    }
};
const mergerContactMap = (left, right) => {
    const leftKeys = Object.keys(left);
    const rightKeys = Object.keys(right);
    const result = {};
    new Set([...leftKeys, ...rightKeys]).forEach(contactId => {
        const leftItem = left[contactId];
        const rightItem = right[contactId];
        if (leftItem && rightItem) {
            const customerOrgModel = leftItem.customerOrgModel;
            if (customerOrgModel) {
                rightItem.customerOrgModel.relatedCompanyInfo = leftItem.customerOrgModel.relatedCompanyInfo;
            }
            result[contactId] = rightItem;
        }
        else if (leftItem) {
            result[contactId] = leftItem;
        }
        else if (rightItem) {
            result[contactId] = rightItem;
        }
    });
    return result;
};
export const doUpdateEmailIdMap = (updateEmailIdMap) => {
    const dispatch = store.dispatch;
    dispatch(actions._doUpdateEmailIdMap(updateEmailIdMap));
};
export const doUpdateContactMap = (params) => {
    const dispatch = store.dispatch;
    let updateContactMap = {};
    if (params && !Array.isArray(params)) {
        Object.keys(params).forEach(_account => {
            const list = params[_account];
            list.forEach(item => {
                const contactId = item === null || item === void 0 ? void 0 : item.contact.id;
                if (contactId) {
                    updateContactMap[contactId] = Object.assign(Object.assign({}, item), { _account });
                }
            });
        });
    }
    else {
        updateContactMap = lodashKeyBy(params, 'contact.id');
    }
    dispatch(actions._doUpdateContactMap(updateContactMap));
};
export const doUpdateLxContactMap = doUpdateContactMap;
export const doUpdateCustomerContactMap = doUpdateContactMap;
const _getMyCustomerList = async (_params) => {
    const params = _params || { limit: 50, page: 1 };
    const pageSize = params.limit || 50;
    const _page = (_params === null || _params === void 0 ? void 0 : _params.force) ? 1 : params.page || 1;
    const { data: list, page } = await mailPlusCustomerApi.doGetMyCustomerByGroup({ pageSize, page: _page, filterEmptyCustomer: true });
    const { customerList } = transServerCustomerModel(list, 'customer');
    const customerIdList = [];
    customerList.forEach(item => {
        customerIdList.push(item.id);
    });
    return {
        customerList,
        customerIdList,
        loadMore: pageSize === list.length,
        page,
    };
};
export const doGetMyCustomerListFromReducer = async (params) => {
    const dispatch = store.dispatch;
    const state = store.getState();
    const { customerMap, myCustomerList } = state.contactReducer;
    let { idList, loadMore, page: lastPage } = myCustomerList;
    const page = (params === null || params === void 0 ? void 0 : params.force) ? 1 : (params === null || params === void 0 ? void 0 : params.page) || lastPage + 1;
    const needUpdateIdList = [];
    let displayList = [];
    if (loadMore && lastPage < page) {
        const { customerList, customerIdList, loadMore: _loadMore } = await _getMyCustomerList({ limit: (params === null || params === void 0 ? void 0 : params.limit) || 50, page });
        loadMore = _loadMore;
        displayList = [...customerIdList];
        let updateCustomerMap = {};
        if (customerList === null || customerList === void 0 ? void 0 : customerList.length) {
            updateCustomerMap = lodashKeyBy(customerList, 'id');
        }
        setContactReducerStateData({
            updateCustomerMap,
        });
        dispatch(actions.doUpdateMyCustomerList({
            loadMore,
            idList: [...idList, ...customerIdList],
            page,
        }));
    }
    else {
        idList.forEach(customerId => {
            const customerDetail = customerMap[customerId];
            if (customerDetail) {
                displayList.push(customerDetail.id);
            }
            else {
                needUpdateIdList.push(customerId);
            }
        });
    }
    if (needUpdateIdList.length > 0) {
        console.error('[contactReducer] doGetMyCustomerList needUpdateIdList error, why happened', needUpdateIdList);
    }
    return { idList: displayList, loadMore };
};
export const doGetMyCustomerList = _getMyCustomerList;
export const doGetCustomerContactListById = async (params) => {
    const { id, page } = params;
    const { data, totalSize } = await mailPlusCustomerApi.doGetContactListByCompanyId({
        id,
        pageSize: 50,
        page,
        filterEmptyContact: true,
        emailRole: 'myCustomer',
    });
    const list = data.map(transServerCustomerContact2SimpleContactModel);
    const hasMore = page < totalSize;
    return {
        data: list,
        hasMore,
        page,
    };
};
export const refreshContactData = async (cleanList = false) => {
    try {
        const accountMap = mailPlusCustomerApi.doGetDisplayEmailLabelMap();
        const accountEmailMap = {};
        let emailNameMap = new Map();
        accountMap.forEach((item, _account) => {
            if (_account && item) {
                accountEmailMap[_account] = [...item.keys()];
                emailNameMap = new Map([...emailNameMap, ...item]);
            }
        });
        let { updateEmailIdMap, updateContactMap = {}, contactPromiseList } = await getEmailRoleByEmails(accountEmailMap, emailNameMap, true);
        if (contactPromiseList === null || contactPromiseList === void 0 ? void 0 : contactPromiseList.length) {
            const lxData = await Promise.all(contactPromiseList);
            const lxContactList = lxData.flat();
            if (lxContactList === null || lxContactList === void 0 ? void 0 : lxContactList.length) {
                updateContactMap = mergerContactMap(updateContactMap, lodashKeyBy(lxContactList, 'contact.id'));
            }
        }
        store.dispatch(actions.doResetContactData({
            updateEmailIdMap,
            updateContactMap,
            updateCustomerMap: {},
        }));
        if (cleanList) {
            await store.dispatch(actions.doCleanMyCustomerList());
        }
        return true;
    }
    catch (e) {
        console.error('[contactReducer] refreshContactData error', e);
        return false;
    }
};
export const refreshCustomerDataByIds = async (ids) => {
    try {
        if (!(ids === null || ids === void 0 ? void 0 : ids.length)) {
            console.error('请输入要刷新的客户id');
            return false;
        }
        const { contactIdList: deleteContactIdList, emailAccountList: accountEmailMap, emailNameMap } = getCustomerLinkData(ids);
        const res = await getEmailRoleAndDetailByEmails(accountEmailMap, emailNameMap);
        setContactReducerStateData(Object.assign(Object.assign({}, res), { deleteContactIdList, deleteCustomerIdList: ids }));
        return true;
    }
    catch (e) {
        console.error('[contactReducer] refreshCustomerDataByIds error', e);
        return false;
    }
};
export const refreshContactDataByEmails = async (accountEmailMap, emailNameMap) => {
    var _a;
    try {
        if (!accountEmailMap || !((_a = Object.keys(accountEmailMap)) === null || _a === void 0 ? void 0 : _a.length)) {
            console.error('请输入要刷新的email');
            return false;
        }
        const res = await getEmailRoleAndDetailByEmails(accountEmailMap, emailNameMap);
        if (res.updateCustomerMap) {
            await refreshMyCustomerList();
        }
        setContactReducerStateData(res);
        return true;
    }
    catch (e) {
        console.error('[contactReducer] refreshCustomerDataByIds error', e);
        return false;
    }
};
export const refreshMyCustomerList = async () => {
    try {
        const dispatch = store.dispatch;
        const { customerIdList, loadMore, customerList, page } = await _getMyCustomerList({ force: true });
        setContactReducerStateData({
            updateCustomerMap: lodashKeyBy(customerList, 'id'),
        });
        dispatch(actions.doUpdateMyCustomerList({ idList: customerIdList, loadMore, page }));
        sendCustomerMapChangeNotify({ idList: customerIdList, isFull: false });
        return true;
    }
    catch (e) {
        console.error('[contactReducer] refreshMyCustomerList error', e);
        return false;
    }
};
const sendCustomerMapChangeNotify = (params) => {
    const { isFull, idList } = params;
    eventApi.sendSysEvent({
        eventName: 'customerMapChangeNotify',
        eventData: {
            target: isFull ? 'all' : 'myCustomerList',
            idList,
        },
        eventSeq: 0,
    });
    console.warn('[contactReducer] ~ sendEdmNotify ~ params:', params);
};
export const getEmailRoleByEmails = async (accountEmailMap, emailNameMap = new Map(), needUpdateLxDetail) => {
    const promiseList = Object.keys(accountEmailMap).reduce((arr, _account) => {
        var _a;
        const emails = [...new Set(accountEmailMap[_account])];
        arr.push(mailPlusCustomerApi.doGetRoleByEmail({ emails, _account, useEdm: process.env.BUILD_ISEDM || ((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion) }).then(roleRes => {
            const updateContactMap = {};
            const updateCustomerIds = [];
            const updateEmailIdMap = {};
            const requestLxIds = [];
            const reduxUpdateTime = Date.now();
            emails.forEach(email => {
                const val = roleRes[email];
                const accountEmailKey = createAccountEmailKey(email, _account);
                if (val) {
                    updateEmailIdMap[accountEmailKey] = val.contactId;
                    if (val.companyId) {
                        updateCustomerIds.push(val.companyId);
                        updateContactMap[val.contactId] = transEmailRoleBase2ContactModel(val);
                    }
                    else {
                        requestLxIds.push(val.contactId);
                    }
                }
                else {
                    const externalId = 'external_id_' + email;
                    const name = emailNameMap.get(email) || email;
                    const contactModelItem = buildContactModel({ email, type: 'external', name, id: externalId, _account }, { reduxUpdateTime, _account, isFull: true });
                    updateContactMap[externalId] = contactModelItem;
                    updateEmailIdMap[accountEmailKey] = externalId;
                }
            });
            return {
                updateEmailIdMap,
                updateContactMap,
                updateCustomerIds,
                updateLxContactIds: [_account, requestLxIds],
            };
        }));
        return arr;
    }, []);
    const promiseListRes = await Promise.all(promiseList);
    const { updateCustomerIds, contactPromiseList, updateEmailIdMap, updateContactMap } = promiseListRes.reduce((obj, item) => {
        var _a, _b;
        if ((_a = item === null || item === void 0 ? void 0 : item.updateCustomerIds) === null || _a === void 0 ? void 0 : _a.length) {
            obj.updateCustomerIds.push(...item.updateCustomerIds);
        }
        if (((_b = item === null || item === void 0 ? void 0 : item.updateLxContactIds) === null || _b === void 0 ? void 0 : _b.length) && needUpdateLxDetail) {
            const [_account, lxIds] = item.updateLxContactIds;
            obj.contactPromiseList.push(contactApi.doGetContactById(lxIds, _account).then(res => contactDataAddReduxParams(res, true, _account)));
        }
        if (!isEmpty(item.updateEmailIdMap)) {
            obj.updateEmailIdMap = Object.assign({}, item.updateEmailIdMap);
        }
        if (!isEmpty(item.updateContactMap)) {
            obj.updateContactMap = Object.assign({}, item.updateContactMap);
        }
        return obj;
    }, {
        updateCustomerIds: [],
        contactPromiseList: [],
        updateEmailIdMap: {},
        updateContactMap: {},
    });
    return {
        updateCustomerIds,
        contactPromiseList,
        updateEmailIdMap,
        updateContactMap,
    };
};
export const getEmailRoleAndDetailByEmails = async (accountEmailMap, emailNameMap = new Map()) => {
    const { updateCustomerIds, contactPromiseList, updateEmailIdMap, updateContactMap: roleUpdateContactMap, } = await getEmailRoleByEmails(accountEmailMap, emailNameMap, true);
    const updateCustomerIdRoleMap = {};
    roleUpdateContactMap &&
        Object.values(roleUpdateContactMap).forEach(contactModel => {
            const { role, companyId } = (contactModel === null || contactModel === void 0 ? void 0 : contactModel.customerOrgModel) || {};
            if (companyId && role) {
                updateCustomerIdRoleMap[companyId] = role;
            }
        });
    const [updateCustomerMap, lxContactList] = await Promise.all([
        (updateCustomerIds === null || updateCustomerIds === void 0 ? void 0 : updateCustomerIds.length)
            ? getCustomerDataByIds(updateCustomerIds, updateCustomerIdRoleMap).then(res => {
                return res.customerMap;
            })
            : Promise.resolve(undefined),
        Promise.all(contactPromiseList).then(lxData => {
            const lxContactList = lxData.flat();
            return lxContactList;
        }),
    ]);
    const updateContactMap = mergerContactMap(roleUpdateContactMap || {}, lodashKeyBy(lxContactList, 'contact.id'));
    return {
        updateEmailIdMap,
        updateContactMap,
        updateCustomerMap,
    };
};
const setContactReducerStateData = (params) => {
    const { deleteCustomerIdList = [], deleteContactIdList = [], updateCustomerMap, updateContactMap, updateEmailIdMap } = params;
    let willDeleteCustomerIds, willDeleteContactIds;
    if (updateCustomerMap && !isEmpty(updateCustomerMap)) {
        if (deleteCustomerIdList === null || deleteCustomerIdList === void 0 ? void 0 : deleteCustomerIdList.length) {
            const oldKeys = Object.keys(updateCustomerMap);
            const diff = util.getDiffNew(oldKeys, deleteCustomerIdList);
            willDeleteCustomerIds = diff.insertDiff;
        }
        store.dispatch(actions.doUpdateCustomerMap(updateCustomerMap));
    }
    if (updateContactMap && !isEmpty(updateContactMap)) {
        if (deleteContactIdList === null || deleteContactIdList === void 0 ? void 0 : deleteContactIdList.length) {
            const oldKeys = Object.keys(updateContactMap);
            const diff = util.getDiffNew(oldKeys, deleteContactIdList);
            willDeleteContactIds = diff.insertDiff;
        }
        store.dispatch(actions._doUpdateContactMap(updateContactMap));
    }
    if (updateEmailIdMap && !isEmpty(updateEmailIdMap)) {
        store.dispatch(actions._doUpdateEmailIdMap(updateEmailIdMap));
    }
    console.log(`willDeleteCustomerIds: ${willDeleteCustomerIds}, willDeleteContactIds: ${willDeleteContactIds}`);
};
export const doGetCustomerContactByEmails = async (params) => {
    const { emails } = params;
    if (!(emails === null || emails === void 0 ? void 0 : emails.length)) {
        return {};
    }
    const res = await mailPlusCustomerApi.doGetRoleByEmail({ emails, useLx: false });
    const resultEmails = Object.keys(res);
    if (resultEmails === null || resultEmails === void 0 ? void 0 : resultEmails.length) {
        return resultEmails.reduce((obj, email) => {
            const item = res[email];
            if (item) {
                obj[email] = transEmailRoleBase2ContactModel(item);
            }
            return obj;
        }, {});
    }
    return {};
};
export const doGetCustomerContactByCustomerIds = async (params) => {
    const { idList } = params;
    const idRoleMap = {};
    if (idList && idList.length) {
        idList.forEach(id => {
            idRoleMap[id] = 'myCustomer';
        });
    }
    const { contactMap } = await getCustomerDataByIds(idList, idRoleMap);
    return contactMap;
};
const getCustomerLinkData = (cutsomerIdList) => {
    const state = store.getState().contactReducer;
    const contactIdList = [];
    const idNameMap = new Map();
    cutsomerIdList === null || cutsomerIdList === void 0 ? void 0 : cutsomerIdList.forEach(customerId => {
        var _a;
        const curCustomer = state.customerMap[customerId];
        (_a = curCustomer === null || curCustomer === void 0 ? void 0 : curCustomer.contactList) === null || _a === void 0 ? void 0 : _a.forEach(item => {
            contactIdList.push(item.id);
            idNameMap.set(item.id, item.name);
        });
    });
    const emailNameMap = new Map();
    const emailAccountList = Object.keys(state.emailIdMap).reduce((obj, accountEmail) => {
        const curContactId = state.emailIdMap[accountEmail];
        if (curContactId && contactIdList.includes(curContactId)) {
            const paresData = parseAccountEmailKey(accountEmail);
            if (paresData) {
                const emailList = obj[paresData.account] || [];
                emailList.push(paresData.email);
                emailNameMap.set(paresData.email, idNameMap.get(curContactId) || paresData.email);
                obj[paresData.account] = emailList;
            }
        }
        return obj;
    }, {});
    return {
        cutsomerIdList,
        contactIdList,
        emailAccountList,
        emailNameMap,
    };
};
export const getVisitedCustomerContactMap = (id) => {
    const state = store.getState().contactReducer;
    return state.visitedCustomerContactMap[id];
};
export const setVisitedCustomerContactMap = (id, data) => {
    return store.dispatch(actions.doUpdateVisitedCustomerContactMap({ id, data }));
};
export const cleanVisitedCustomerContactMap = () => {
    return store.dispatch(actions.doCleanVisitedCustomerContactMap());
};
export const { actions } = contactSlice;
export default contactSlice.reducer;
